import { useQuery, useMutation } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Service {
  id: string;
  name: string;
  description: string | null;
  active: boolean;
  sort_order: number;
  created_at: string;
  welcome_message: string | null;
  bg_image_url: string | null;
  assigned_agent_id: string | null;
}

export function useActiveServices() {
  return useQuery({
    queryKey: ["services", "active"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("services")
        .select("*")
        .eq("active", true)
        .order("sort_order", { ascending: true })
        .order("created_at", { ascending: true });

      if (error) throw error;
      return data as Service[];
    },
  });
}

export function useCreateConversation() {
  return useMutation({
    mutationFn: async ({ userId, serviceId }: { userId: string; serviceId: string }) => {
      const { data, error } = await supabase
        .from("conversations")
        .insert({
          user_id: userId,
          service_id: serviceId,
          subject: "Nouvelle demande",
          status: "open",
        })
        .select()
        .single();

      if (error) throw error;
      return data;
    },
  });
}

export async function createConversationWithService(userId: string, serviceId: string) {
  const { data, error } = await supabase
    .from("conversations")
    .insert({
      user_id: userId,
      service_id: serviceId,
      subject: "New Request",
      status: "open",
    })
    .select()
    .single();

  if (error) throw error;
  return data;
}
